/* eslint camelcase: 0 */
import { Login } from '@/infrastructure/network/Legacy/schema'
import { IAccountProps } from '@/entities/Account'

export const toLoginRequest = (props: IAccountProps): Login => {
  const { username, password } = props
  return {
    username: username!,
    password: password!
  }
}
